import type { Target } from '../types'

const createTarget = (): Target => ({
  stack: []
})

export default createTarget
